import { injectIntl } from 'gatsby-plugin-intl';
import React from 'react';
import { Helmet } from 'react-helmet';
import { IntlShape } from 'react-intl';
import languageNames from '../../../intl';
import useSiteMetadata from '../../../hooks/SiteMetadata';
import FAVICON from '../../../assets/images/favicon.ico';
import { Msg } from '../../../utils/helpers/MsgHelper';

/**
 * @interface SEOProps
 * @description Contains SEO components props attributes and types
 */
interface SEOProps {
  /**
   * @field intl
   * @description Internationalization object
   * @type {IntlShape}
   * @memberof SEOProps
   */
  intl: IntlShape;
}

const defaultUrl = 'http://www.sapiens.digital/';

/**
 * @component SEO
 * @description will add page title and seo related meta data
 */
export const SEO: React.FC<SEOProps> = ({ intl }) => {
  const { theme, url } = useSiteMetadata();
  return (
    <Helmet>
      <html lang={intl.locale} />
      <title>{Msg(intl, 'SEO.title')}</title>
      <meta charSet='utf-8' />
      {Object.keys(languageNames).map((language: string) => (
        <link rel='alternate' hrefLang={language} href={`${defaultUrl}${language}`} key={language} />
      ))}
      <link rel='icon' type='image/png' href={FAVICON} sizes='16x16' />
      <link rel='alternate' hrefLang='x-default' href={defaultUrl} />
      <meta name='description' content={Msg(intl, 'SEO.description')} />
      <meta name='theme-color' content={theme} />
      <meta property='og:type' content={Msg(intl, 'SEO.type')} />
      <meta property='og:title' content={Msg(intl, 'SEO.title')} />
      <meta property='og:url' content={url} />
      <meta name='format-detection' content='telephone=no' />
    </Helmet>
  );
};

export default injectIntl(SEO);
